import { Component } from '@angular/core';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { RouterOutlet } from '@angular/router';
import { Icons } from './domain/enums/icons-enums';
import { SessionExpiryBannerComponent } from './common/session-expiry-banner/session-expiry-banner.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, MatIconModule, SessionExpiryBannerComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent {
  title = 'tourist-internal';

  constructor(
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer
  ) {

    const icons = Object.values(Icons);
    this.registerSVGIcon(icons);
  }

  registerSVGIcon(icons: string[]) {
    icons.forEach(icon => {
      this.matIconRegistry.addSvgIcon(
        icon,
        this.domSanitizer.bypassSecurityTrustResourceUrl(`icons/${icon}.svg`)
      );
    });
  }

}
